import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { SERVICES } from "@/lib/services";
import { Input } from "@/components/ui/input";

const small = "rounded-lg bg-white border-[#103080]/20 h-10 w-20";

export default function DeadlinesCard() {
  const [rules, setRules] = useState(null);

  useEffect(() => {
    api.get("/deadline-rules").then((r) => setRules(r.data)).catch((e) => toast.error(formatApiError(e)));
  }, []);

  if (!rules) return null;
  const set = (key, field, value) => setRules((p) => ({ ...p, [key]: { months: 0, days: 0, ...p[key], [field]: Number(value) || 0 } }));
  const save = async () => {
    const body = Object.fromEntries(Object.entries(rules).filter(([, r]) => r && (r.months || r.days)));
    try {
      setRules(await api.put("/deadline-rules", body).then((r) => r.data));
      toast.success("Internal deadlines saved. They apply to services you onboard from now on.");
    } catch (e) {
      toast.error(formatApiError(e));
    }
  };

  return (
    <section className="max-w-4xl rounded-2xl border border-[#103080]/10 bg-white/70 ambient p-6 sm:p-8" data-testid="deadlines-card">
      <h2 className="font-serif-brand font-semibold text-2xl text-[#103080]">Internal deadlines</h2>
      <p className="text-sm text-[#0F172A]/60 mt-1 mb-5">
        How long after the period or year end your firm aims to finish each service. When you onboard a service, the internal deadline is worked out for you and the statutory deadline is shown next to it. Leave a service at 0 to use the statutory deadline.
      </p>
      <ul className="divide-y divide-[#103080]/10">
        {SERVICES.filter((s) => !s.hideDue).map((s) => (
          <li key={s.key} className="flex flex-wrap items-center gap-3 py-3" data-testid={`deadline-rule-${s.key}`}>
            <span className="flex-1 min-w-[200px] font-semibold text-[#103080]">{s.label}</span>
            <Input type="number" min={0} max={36} value={rules[s.key]?.months || 0} onChange={(e) => set(s.key, "months", e.target.value)} className={small} data-testid={`deadline-rule-${s.key}-months`} />
            <span className="text-sm text-[#0F172A]/60">months</span>
            <Input type="number" min={0} max={365} value={rules[s.key]?.days || 0} onChange={(e) => set(s.key, "days", e.target.value)} className={small} data-testid={`deadline-rule-${s.key}-days`} />
            <span className="text-sm text-[#0F172A]/60">days after the period end</span>
          </li>
        ))}
      </ul>
      <button onClick={save} data-testid="deadline-rules-save"
        className="mt-5 rounded-full bg-[#103080] text-white font-medium px-7 h-11 text-sm hover:bg-[#0090D0] transition-colors duration-200">Save deadlines</button>
    </section>
  );
}
